export const isLightHouse = () => /Chrome-Lighthouse/i.test(navigator.userAgent)
